import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import AhaEditorV2Controller from '../controllers/AhaEditorV2Controller';
import { type ComponentProps, type CustomElement } from '../types/aha-editor';

export const DefaultElement: React.FC<
  Omit<ComponentProps<CustomElement>, 'element' | 'transformedElement'>
> = ({ attributes, children }) => {
  return <p {...attributes}>{children}</p>;
};

const ElementComponent: React.FC<
  Omit<ComponentProps<CustomElement>, 'transformedElement'>
> = ({ element, children, attributes }) => {
  const controller = useController(AhaEditorV2Controller);
  const { ahaEditor } = controller;
  const Component = ahaEditor.getComponent(element.type);

  if (Component) {
    return (
      <Component
        attributes={attributes}
        element={element}
        transformedElement={ahaEditor.transformElement(element)}
      >
        {children}
      </Component>
    );
  }

  return <DefaultElement attributes={attributes}>{children}</DefaultElement>;
};

export default ApplicationView(ElementComponent);
